// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kQM3rrm6tS6I027Arx1R {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 37px;
}

.IieNtl5gGmVeDFXD2yBk {
  text-align: center;
  font-size: 32px;
  font-weight: 540;
  line-height: 129%;
  letter-spacing: 0.43px;
  margin-bottom: 21px;
}

.OOffucU5fGKO77GWTe8e {
  min-width: 80px;
  min-height: 80px;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 760;
  line-height: 100%;
  color: #fff;
  background: #007AFF;
  text-align: center;
  margin-bottom: 24px;
}

.b0znTrkpAElDUhwQt33l {
  color: #34C759;
  font-size: 35px;
  font-weight: 540;
  line-height: 68%;
  text-align: center;
  margin-bottom: 14px;
}

.uYkHONYAELOYhVMuaTbW {
  color: #8E8E93 !important;
}

.C2QIec7u8cCeFvqYb6cB {
  text-align: center;
  font-size: 18px;
  line-height: 129%;
  letter-spacing: -0.5px;
}

.go9sYjmC8ePrc4Z3sUwq {
  padding: 14px 21px;
  font-size: 17px;
  font-weight: 540;
  line-height: 129%;
  border-radius: 12px;
  background: #007AFF;
  letter-spacing: 0.63px;
  height: auto;
}

.go9sYjmC8ePrc4Z3sUwq:hover {
  background: #007AFF;
}

.qQ1IofcT9wm_ZNGzEfDi {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px; 
  border-radius: 28px;
  border: 1px solid rgba(var(--border), 0.20);
  background: rgba(var(--secondary-bg), 0.40);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  width: 100%;
  overflow-y: auto;
}

.tROfJ1m85G1wTvAC8T8s {
  font-size: 18px;
  font-weight: 540;
  margin-bottom: 16px;
  color: rgb(var(--placeholder-primary));
}

.feI4v3oHIOBrkYCR175d {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 0;
}

.feI4v3oHIOBrkYCR175d:not(:last-child)::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 1px;
  /* background: rgba(116, 116, 128, 0.4); */
  border-bottom: 1px dashed rgba(116, 116, 128, 0.4);
}

.feI4v3oHIOBrkYCR175d:not(:last-child) {
  margin-bottom: 5px;
}

.xfKBTGzazYLpnR1iumTO,
.yYpR9aUtKUU8geHI48M4 {
  font-size: 17px;
  line-height: 129%;
}

.xfKBTGzazYLpnR1iumTO {
  color: rgb(var(--placeholder-secondary));
}

.yYpR9aUtKUU8geHI48M4 {
  font-weight: 540;
  word-break: break-word;
}

.go9sYjmC8ePrc4Z3sUwq {
  margin-top: auto;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/detail-transaction/detail-transaction.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".contentTop {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin-bottom: 37px;\n}\n\n.status {\n  text-align: center;\n  font-size: 32px;\n  font-weight: 540;\n  line-height: 129%;\n  letter-spacing: 0.43px;\n  margin-bottom: 21px;\n}\n\n.avatar {\n  min-width: 80px;\n  min-height: 80px;\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 32px;\n  font-weight: 760;\n  line-height: 100%;\n  color: #fff;\n  background: #007AFF;\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.amount {\n  color: #34C759;\n  font-size: 35px;\n  font-weight: 540;\n  line-height: 68%;\n  text-align: center;\n  margin-bottom: 14px;\n}\n\n.amountMinus {\n  color: #8E8E93 !important;\n}\n\n.date {\n  text-align: center;\n  font-size: 18px;\n  line-height: 129%;\n  letter-spacing: -0.5px;\n}\n\n.btn {\n  padding: 14px 21px;\n  font-size: 17px;\n  font-weight: 540;\n  line-height: 129%;\n  border-radius: 12px;\n  background: #007AFF;\n  letter-spacing: 0.63px;\n  height: auto;\n}\n\n.btn:hover {\n  background: #007AFF;\n}\n\n.contentBottom {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 16px; \n  border-radius: 28px;\n  border: 1px solid rgba(var(--border), 0.20);\n  background: rgba(var(--secondary-bg), 0.40);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px);\n  width: 100%;\n  overflow-y: auto;\n}\n\n.contentTitle {\n  font-size: 18px;\n  font-weight: 540;\n  margin-bottom: 16px;\n  color: rgb(var(--placeholder-primary));\n}\n\n.contentItem {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px 0;\n}\n\n.contentItem:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 1px;\n  /* background: rgba(116, 116, 128, 0.4); */\n  border-bottom: 1px dashed rgba(116, 116, 128, 0.4);\n}\n\n.contentItem:not(:last-child) {\n  margin-bottom: 5px;\n}\n\n.contentItemLeft,\n.contentItemRight {\n  font-size: 17px;\n  line-height: 129%;\n}\n\n.contentItemLeft {\n  color: rgb(var(--placeholder-secondary));\n}\n\n.contentItemRight {\n  font-weight: 540;\n  word-break: break-word;\n}\n\n.btn {\n  margin-top: auto;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentTop": `kQM3rrm6tS6I027Arx1R`,
	"status": `IieNtl5gGmVeDFXD2yBk`,
	"avatar": `OOffucU5fGKO77GWTe8e`,
	"amount": `b0znTrkpAElDUhwQt33l`,
	"amountMinus": `uYkHONYAELOYhVMuaTbW`,
	"date": `C2QIec7u8cCeFvqYb6cB`,
	"btn": `go9sYjmC8ePrc4Z3sUwq`,
	"contentBottom": `qQ1IofcT9wm_ZNGzEfDi`,
	"contentTitle": `tROfJ1m85G1wTvAC8T8s`,
	"contentItem": `feI4v3oHIOBrkYCR175d`,
	"contentItemLeft": `xfKBTGzazYLpnR1iumTO`,
	"contentItemRight": `yYpR9aUtKUU8geHI48M4`
};
export default ___CSS_LOADER_EXPORT___;
